import { connect } from 'react-redux';
import { pickBy, groupBy, sortBy } from 'lodash';
import * as moment from 'moment';
import DashboardView from './dashboard.component';
import { formatDate } from '../donation/DonationsTable';

const getDonationsVals = (donations) => {
  let totalVal = 0;
  let values = {
    totalNoOfDonations: null,
    donations:[],
    totalDonations: null
  };
  const lastWeek = Date.now() - (7 * 24 * 60 * 60 * 1000);
  const filteredIds = Object.keys(donations).filter(i => (new Date(donations[i].timestamp).getTime()> lastWeek) );
  const filteredDonations = filteredIds.map(i => ({amount: donations[i].amount, timestamp: formatDate(donations[i].timestamp) }));
  const groupedDonations = groupBy(filteredDonations, 'timestamp')
  for(let i =0; i < 7; i++) {
    const date = formatDate(lastWeek + i * (24 * 60 * 60 * 1000));
    if (!groupedDonations[date]) {
      groupedDonations[date] = []
    }
  }
  let sortedDonationKeys = Object.keys(groupedDonations);
  sortedDonationKeys = sortBy(sortedDonationKeys, function(o) { return new Date(o); })
  values.donations = sortedDonationKeys.map(groupDonationKey => {
    let dateVal = 0
    groupedDonations[groupDonationKey].forEach(donation => {
      let amount = donation.amount || 0;
      if(amount && amount.includes('£')) {
        amount = amount.substring(1);
      }
      dateVal += parseInt(amount);
    });
    return dateVal;
  })

  Object.keys(donations).forEach(donation => {
    let amount = donations[donation].amount || 0;
    const type = donations[donation].type;
    if(amount && amount.includes('£')) {
      amount = amount.substring(1);
    }
    if(amount && type  === 'monthly') {
      const noOfMonths = moment(moment()).diff(donations[donation].timestamp, "months");
      amount = parseInt(amount) + (parseInt(amount) * noOfMonths);
    }
    totalVal += parseInt(amount);
  });
  values.totalNoOfDonations = Object.keys(donations).length;
  values.totalDonations = totalVal;
  return values;
}

const mapStateToProps = ({ charities, campaigns, placements, donations, auth}) => {
  let dashboardValues = {
    totalCharities: null,
    totalDonations: null,
    totalPlacements: null,
    totalCampaigns: null,
    totalNoOfDonations: null,
    donations:[]
  };
  if (!auth.isAdmin && !auth.charityKey) return { dashboardValues, auth }

  const campaignsData = campaigns.all;
  const donationsData = donations.all;
  const charitiesData = charities.all;
  const { charityKey } = auth;
  if (charityKey) {
    const pickedDonations = pickBy(donationsData, donation  => donation.selectedCharityId === charityKey || donation.charityId === charityKey);
    const pickedCampaigns = pickBy(campaignsData, campaign => campaign.charities.hasOwnProperty(charityKey) && campaign.charities[charityKey]);
    const donationsValues = getDonationsVals(pickedDonations);
    dashboardValues.totalCampaigns = Object.keys(pickedCampaigns).length;
    dashboardValues = { ...dashboardValues, ...donationsValues}
  }
  else {
    const donationsValues = getDonationsVals(donationsData);
    dashboardValues.totalCampaigns = Object.keys(campaignsData || {}).length;
    dashboardValues.totalPlacements = Object.keys(placements.all || {}).length;
    dashboardValues.totalCharities = Object.keys(charitiesData || {}).length;
    dashboardValues = { ...dashboardValues, ...donationsValues}

  }
  return {
    dashboardValues,
    auth: auth
  }
};

export default connect(mapStateToProps)(DashboardView);
